<template>
  <Layout>
    <div class="row">
      <PageHeader class="col-11" title="VMS Device Management" />
    </div>

    <!-- Search and Create new package -->
    <div class="row mb-2">
      <div class="col-sm-4">
        <div class="search-box me-2 mb-2 d-inline-block">
          <div class="position-relative">
            <b-form-input
              type="search"
              v-model="filter"
              class="form-control"
              placeholder="Search VMS"
            ></b-form-input>
            <i class="bx bx-search-alt search-icon"></i>
          </div>
        </div>
      </div>
      <div class="col-sm-8">
        <div class="text-sm-end">
          <button
            type="button"
            @click="showAddVmsModal"
            class="btn btn-info btn-rounded mb-2 me-2"
          >
            <i class="mdi mdi-plus me-1"></i
            >{{ $t("menuitems.administration.list.vmsDevice.list.add") }}
          </button>
        </div>
      </div>
    </div>
    <!-- Company Table -->
    <div class="table-responsive mb-0">
      <b-table
        class="datatables"
        :items="allVmsDevices"
        :fields="fields"
        responsive="sm"
        :sort-by.sync="sortBy"
        :sort-desc.sync="sortDesc"
        :filter="filter"
        :filter-included-fields="filterOn"
      >
        <template #cell(created_at)="row">
          <span
            >{{ new Date(row.item.created_at).toDateString() }}
            {{ new Date(row.item.created_at).toLocaleTimeString() }}</span
          >
        </template>

        <template #cell(actions)="row">
          <b-button
            size="sm"
            variant="primary"
            class="m-1"
            @click="showUpdateVmsModal(row.item)"
          >
            Edit
          </b-button>
          <b-button
            size="sm"
            variant="danger"
            class="m-1"
            @click="deleteVmsDevice(row.item)"
          >
            Delete
          </b-button>
        </template>
      </b-table>
    </div>

    <!-- Create vms modal -->
    <b-modal
      id="create-new-vms-modal"
      title="Add New VMS Device"
      no-close-on-backdrop
      hide-footer
      size="lg"
    >
      <template #modal-header>
        <div><h5>Add New VMS Device</h5></div>
        <div>
          <button
            class="btn btn-sm btn-outline-danger"
            @click="closeAddNewModal()"
          >
            Cancel
          </button>
        </div>
      </template>

      <form @submit.prevent="addNewVMSDevice">
        <div class="row">
          <div class="col-12">
            <div class="card">
              <div class="card-body">
                <div class="table-responsive">
                  <table class="table mb-0">
                    <tbody>
                      <tr>
                        <th scope="row">VMS Name</th>
                        <td>
                          <input
                            placeholder="Enter VMS Name"
                            v-model="vmsName"
                            type="text"
                            class="form-control inp-bg"
                            required
                          />
                        </td>
                      </tr>
                      <tr>
                        <th scope="row">VMS IP</th>
                        <td>
                          <input
                            placeholder="Enter VMS IP"
                            v-model="vmsIp"
                            type="text"
                            class="form-control inp-bg"
                            required
                          />
                        </td>
                      </tr>
                      <tr>
                        <th scope="row">Chainage</th>
                        <td>
                          <input
                            placeholder="Enter/ Paste Chainage"
                            v-model="vmsChainage"
                            type="text"
                            class="form-control inp-bg"
                            required
                          />
                        </td>
                      </tr>
                      <tr>
                        <th scope="row">Package</th>
                        <td>
                          <v-select
                            class="style-chooser"
                            v-model="vmsPackage"
                            :options="options.packages"
                            :reduce="(packages) => packages.package_name"
                            label="package_name"
                            required
                          ></v-select>
                        </td>
                      </tr>
                      <tr>
                        <th scope="row">Direction</th>
                        <td>
                          <v-select
                            class="style-chooser"
                            v-model="vmsDirection"
                            :options="options.direction"
                            required
                          ></v-select>
                        </td>
                      </tr>

                      <tr>
                        <th scope="row">Type</th>
                        <td>
                          <v-select
                            class="style-chooser"
                            v-model="vmsType"
                            :options="options.type"
                            required
                          ></v-select>
                        </td>
                      </tr>
                      <tr>
                        <th scope="row">VMS Make</th>
                        <td>
                          <v-select
                            class="style-chooser"
                            v-model="vmsMake"
                            :options="options.makes"
                            :reduce="(make) => make.make"
                            label="make"
                            required
                          ></v-select>
                        </td>
                      </tr>
                      <tr>
                        <th scope="row">VMS Model</th>
                        <td>
                          <v-select
                            class="style-chooser"
                            v-model="vmsModel"
                            :options="options.models"
                            :reduce="(model) => model.model"
                            label="model"
                            required
                          ></v-select>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- BUTTON -->
        <div class="row">
          <div class="col-12">
            <div class="mt-2 text-center">
              <button type="submit" class="btn btn-primary me-1 w-50">
                Add VMS Device <i class="bx bx-rocket ml-2"></i>
              </button>
            </div>
          </div>
        </div>
      </form>
    </b-modal>

    <!-- Edit and Update VMS Device -->
    <b-modal
      id="edit-vms-device-modal"
      title="Create New Company"
      title-class="font-18"
      no-close-on-backdrop
      hide-footer
      size="lg"
    >
      <template #modal-header>
        <div><h5>Update VMS Device</h5></div>
        <div>
          <button
            class="btn btn-sm btn-outline-danger"
            @click="$bvModal.hide('edit-vms-device-modal')"
          >
            Cancel
          </button>
        </div>
      </template>

      <form @submit.prevent="updateVmsDevice">
        <div class="row">
          <div class="col-12">
            <div class="card">
              <div class="card-body">
                <div class="table-responsive">
                  <table class="table mb-0">
                    <tbody>
                      <tr>
                        <th scope="row">VMS Name</th>
                        <td>
                          <input
                            placeholder="Enter VMS Name"
                            v-model="selectedVmsDevice.vms_name"
                            type="text"
                            class="form-control inp-bg"
                            required
                          />
                        </td>
                      </tr>
                      <tr>
                        <th scope="row">VMS IP</th>
                        <td>
                          <input
                            placeholder="Enter VMS IP"
                            v-model="selectedVmsDevice.vms_ip"
                            type="text"
                            class="form-control inp-bg"
                            required
                          />
                        </td>
                      </tr>
                      <tr>
                        <th scope="row">Chainage</th>
                        <td>
                          <input
                            placeholder="Enter/ Paste Chainage"
                            v-model="selectedVmsDevice.chainage"
                            type="text"
                            class="form-control inp-bg"
                            required
                          />
                        </td>
                      </tr>
                      <tr>
                        <th scope="row">Package</th>
                        <td>
                          <v-select
                            class="style-chooser"
                            v-model="vmsPackage"
                            :options="options.packages"
                            :reduce="(packages) => packages.package_name"
                            label="package_name"
                            required
                          ></v-select>
                        </td>
                      </tr>
                      <tr>
                        <th scope="row">Direction</th>
                        <td>
                          <v-select
                            class="style-chooser"
                            v-model="vmsDirection"
                            :options="options.direction"
                            required
                          ></v-select>
                        </td>
                      </tr>

                      <tr>
                        <th scope="row">Type</th>
                        <td>
                          <v-select
                            class="style-chooser"
                            v-model="vmsType"
                            :options="options.type"
                            required
                          ></v-select>
                        </td>
                      </tr>
                      <tr>
                        <th scope="row">VMS Make</th>
                        <td>
                          <v-select
                            class="style-chooser"
                            v-model="vmsMake"
                            :options="options.makes"
                            :reduce="(make) => make.make"
                            label="make"
                            required
                          ></v-select>
                        </td>
                      </tr>
                      <tr>
                        <th scope="row">VMS Model</th>
                        <td>
                          <v-select
                            class="style-chooser"
                            v-model="vmsModel"
                            :options="options.models"
                            :reduce="(model) => model.model"
                            label="model"
                            required
                          ></v-select>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- BUTTON -->
        <div class="row">
          <div class="col-12">
            <div class="mt-2 text-center">
              <button type="submit" class="btn btn-primary me-1 w-50">
                Add VMS Device <i class="bx bx-rocket ml-2"></i>
              </button>
            </div>
          </div>
        </div>
      </form>
    </b-modal>
  </Layout>
</template>
<script>
import Layout from "@/layouts/main";
import PageHeader from "@/components/page-header";
import appConfig from "@/app.config";
import vsdsMixin from "../../mixins/administration";
import incidentMixin from "../../mixins/incident";
import vmsMixin from "../../mixins/vms";

import Swal from "sweetalert2";

/**
 * Dashboard Component
 */
export default {
  page: {
    title: "VMS Management",
    meta: [
      {
        name: "description",
        content: appConfig.description,
      },
    ],
  },

  mixins: [vsdsMixin, incidentMixin, vmsMixin],

  data() {
    return {
      allVmsDevices: [],
      companyTypes: [],
      companyNames: [],

      vmsName: null,
      vmsIp: null,
      vmsPackage: null,
      vmsDirection: null,
      vmsChainage: null,
      vmsType: null,
      vmsMake: null,
      vmsModel: null,
      company: null,
      cameras: null,
      speedRadars: null,
      sortBy: "id",
      sortDesc: false,
      filterOn: [],
      filter: null,
      selectedVmsDevice: {},
      options: {
        direction: ["LHS", "RHS"],
        type: ["Cantilever", "Full"],
        models: [],
        makes: [],
        packages: [],
      },
      fields: [
        {
          key: "id",
          label: "ID",
          sortable: false,
        },
        {
          key: "vms_name",
          label: "VMS Name",
          sortable: false,
        },
        {
          key: "vms_ip",
          label: "VMS IP",
          sortable: false,
        },
        {
          key: "chainage",
          label: "Chainage",
          sortable: false,
        },
        {
          key: "package_name",
          label: "Package",
          sortable: false,
        },
        {
          key: "direction",
          label: "Direction",
          sortable: false,
        },
        {
          key: "type",
          label: "Type",
          sortable: false,
        },
        {
          key: "model",
          label: "Model",
          sortable: false,
        },
        {
          key: "make",
          label: "Make",
          sortable: false,
        },
        {
          key: "actions",
          label: "Actions",
          sortable: false,
        },
      ],
    };
  },

  methods: {
    showAddVmsModal() {
      this.vmsName = null;
      this.vmsIp = null;
      this.vmsPackage = null;
      this.vmsDirection = null;
      this.vmsChainage = null;
      this.vmsMake = null;
      this.vmsModel = null;
      this.vmsType = null;
      this.$bvModal.show("create-new-vms-modal");
    },

    async showUpdateVmsModal(vmsData) {
      this.selectedVmsDevice = vmsData;
      const vmsPackage = await this.options.packages.find(
        (packages) => packages.id === this.selectedVmsDevice.package_id
      );
      this.vmsPackage = vmsPackage.package_name;
      this.vmsDirection = this.selectedVmsDevice.direction;
      this.vmsType = this.selectedVmsDevice.type;
      this.vmsMake = this.selectedVmsDevice.make;
      this.vmsModel = this.selectedVmsDevice.model;

      this.$bvModal.show("edit-vms-device-modal");
    },

    closeAddNewModal() {
      this.vmsName = null;
      this.vmsIp = null;
      this.vmsPackage = null;
      this.vmsDirection = null;
      this.vmsChainage = null;
      this.vmsMake = null;
      this.vmsModel = null;
      this.vmsType = null;
      this.$bvModal.hide("create-new-vms-modal");
    },

    async addNewVMSDevice() {
      try {
        const vmsPackage = this.options.packages.find(
          (packages) => packages.package_name === this.vmsPackage
        );
        let data = {
          vms_name: this.vmsName,
          vms_ip: this.vmsIp,
          package: vmsPackage.id,
          direction: this.vmsDirection,
          chainage: this.vmsChainage,
          make: this.vmsMake,
          model: this.vmsModel,
          type: this.vmsType,
        };
        this.$store.dispatch("layout/changeLoaderValue", true);
        await this.CreateVmsDevice(data);
        this.vmsName = null;
        this.vmsIp = null;
        this.vmsPackage = null;
        this.vmsDirection = null;
        this.vmsChainage = null;
        this.vmsMake = null;
        this.vmsModel = null;
        this.vmsType = null;
        this.allVmsDevices = await this.ShowVmsDevices();
        this.$store.dispatch("layout/changeLoaderValue", false);
        this.$bvModal.hide("create-new-vms-modal");
        Swal.fire("VMS Added", "VMS device added successfully", "success");
      } catch (e) {
        this.$store.dispatch("layout/changeLoaderValue", false);
        Swal.fire("Failed!", e.response.data.message, "warning");
      }
    },

    async updateVmsDevice() {
      try {
        const vmsPackage = this.options.packages.find(
          (packages) => packages.package_name === this.vmsPackage
        );

        let data = {
          id: this.selectedVmsDevice.id,
          vms_name: this.selectedVmsDevice.vms_name,
          vms_ip: this.selectedVmsDevice.vms_ip,
          package: vmsPackage.id,
          direction: this.vmsDirection,
          chainage: this.selectedVmsDevice.chainage,
          make: this.vmsMake,
          model: this.vmsModel,
          type: this.vmsType,
        };
        this.$store.dispatch("layout/changeLoaderValue", true);
        await this.UpdateVmsDevice(data);
        this.selectedVmsDevice = {};
        this.allVmsDevices = await this.ShowVmsDevices();
        this.$store.dispatch("layout/changeLoaderValue", false);
        this.$bvModal.hide("edit-vms-device-modal");
        Swal.fire(
          "VMS Device Updated",
          "VMS Device updated successfully",
          "success"
        );
      } catch (e) {
        this.$store.dispatch("layout/changeLoaderValue", false);
        Swal.fire("Failed!", "Failed to update VMS Device", "error");
      }
    },

    async deleteVmsDevice(vms) {
      try {
        const id = {
          id: vms.id,
        };

        Swal.fire({
          title: "Are you sure?",
          text: "You won't be able to revert this!",
          icon: "warning",
          showCancelButton: true,
          confirmButtonColor: "#3085d6",
          cancelButtonColor: "#d33",
          confirmButtonText: "Yes",
        }).then(async (result) => {
          if (result.isConfirmed) {
            Swal.fire("Deleted!", "Your file has been deleted.", "success");
            await this.DeleteVmsDevice(id);
            this.allVmsDevices = await this.ShowVmsDevices();
          }
        });
      } catch (e) {
        Swal.fire("Failed!", "Failed to delete VMS Device", "error");
      }
    },

    async getAllDropdownDetails() {
      try {
        const details = await this.GetIncidentMasters();
        this.options.packages = details.getPackages;
        this.options.makes = details.getVmsMake;
        this.options.models = details.getVmsModel;
      } catch (e) {
        // eslint-disable-next-line no-console
        console.error(e);
        Swal.fire(
          "Network Error",
          "Failed to fetch data from the server. Please check your internet connection.",
          "error"
        );
      }
    },
  },
  components: {
    Layout,
    PageHeader,
  },

  async mounted() {
    this.getAllDropdownDetails();
    this.allVmsDevices = await this.ShowVmsDevices();
  },
};
</script>
